import React from 'react';
import { DatePicker, Space } from 'antd';
import moment from 'moment/moment.js';
import { Button, Dropdown, Spinner } from 'react-bootstrap';
import TableComponent from '../../../../../_metronic/table/TableComponent';
import { useState, useEffect } from 'react';
import Axios from 'axios';
import { useSelector } from 'react-redux';
import swal from 'sweetalert';
import { Select } from 'antd';
import { CSVLink } from 'react-csv';

const dateFormat = 'YYYY-MM-DD';

const { Option } = Select;

export default function ProductwiseSaleReport() {
  // Token From State
  const {
    user: { accessToken, refreshToken },
  } = useSelector((state) => state.auth);
  // Token From State

  const [loading, setLoading] = useState(false);
  const [saleReportList, setSaleReportList] = useState([]);
  const [saleReportTable, setSaleReportTable] = useState(false);
  const [storeData, setStoreData] = useState([]);
  const [store, setStore] = useState([]);
  const [city, setCity] = useState([]);
  const [area, setArea] = useState();
  const [citiesList, setCitiesList] = useState([]);
  const [areasList, setAreasList] = useState([]);

  const [generateReport, setGenerateReport] = useState(false);
  const [storewiseproductReport, setStorewiseproductReport] = useState([]);
  const [headers, setHeaders] = useState([]);

  const [date_from, setDate_from] = useState(
    moment()
      .startOf('month')
      .format(dateFormat)
  );
  const [date_to, setDate_to] = useState(
    moment()
      .endOf('month')
      .format(dateFormat)
  );

  useEffect(() => {
    if (date_to || date_from) {
      getReportData('itemWiseSalesReport', setItemWiseReport, setHeaders2);
      getReportData('itemShopWiseSalesReport', setShopWiseReport, setHeaders4);
    }
  }, [date_to, date_from]);

  useEffect(() => {
    getCities();
    getStoreData();
    getStorewiseproductReport();
    getReportData('itemWiseSalesReport', setItemWiseReport, setHeaders2);
    getReportData('itemShopWiseSalesReport', setShopWiseReport, setHeaders4);
    handleSearch();
  }, []);

  useEffect(() => {
    if (city !== undefined) {
      if (city.length !== 0) {
        getAreaByCity();
      }
    }
  }, [city]);

  // 1- API Get Cities
  const getCities = async () => {
    const { data } = await Axios.post(
      `${process.env.REACT_APP_API_URL}/customer/city`,
      {},
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
          refreshToken: refreshToken,
        },
      }
    );
    if (!data.error) {
      setCitiesList(data.data.data);
    } else {
      swal({
        title: 'Something went wrong',
        icon: 'error',
      });
    }
  };
  // 1- API Get Cities

  // 2- API Get AreaByCity
  const getAreaByCity = async () => {
    const { data } = await Axios.get(
      `${process.env.REACT_APP_API_URL}/polygon/areaByCity/${city}`,
      {},
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
          refreshToken: refreshToken,
        },
      }
    );
    if (!data.error) {
      setAreasList(data.data);
    } else {
      swal({
        title: 'Something went wrong',
        icon: 'error',
      });
    }
  };
  // 2- API Get AreaByCity

  // 3- API Get No. of stores
  const getStoreData = async () => {
    const { data } = await Axios.post(
      `${process.env.REACT_APP_API_URL}/store/list`,
      {},
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
          refreshToken: refreshToken,
        },
      }
    );
    if (!data.error) {
      setStoreData(data.data);
      // setStoreDataSingle(data.data);
    }
  };
  // 3- API Get No. of stores

  // 4- Get Product Sales data by search
  const handleSearch = async () => {
    var searchData = {
      start_date: date_from,
      end_date: date_to,
    };

    if (area !== undefined) {
      searchData.area_id = area;
    }
    if (city?.length !== 0) {
      searchData.city_id = city;
    }
    if (store?.length !== 0) {
      searchData.store_id = store;
    }
    if (searchData?.store_id === undefined) {
      delete searchData.store_id;
    }
    setLoading(true);
    try {
      const { data } = await Axios.post(
        `${process.env.REACT_APP_API_URL}/report/productSalesReport`,
        searchData,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
            refreshToken: refreshToken,
          },
        }
      );
      if (!data.error) {
        setLoading(false);
        if (data.data.length) {
          setSaleReportList(data.data);
          setSaleReportTable(true);
        } else {
          setSaleReportList([]);
          setLoading(false);
        }
      } else {
        setLoading(false);
        swal({
          title: data.message,
          icon: 'info',
        });
      }
    } catch (error) {
      swal({
        title: error.response.data.message,
        icon: 'error',
      });
      setLoading(false);
    }
  };
  // 4- Get Product Sales data by search

  // React Table
  const data = React.useMemo(() => saleReportList, [saleReportList]);

  const columns = React.useMemo(() => [
    {
      Header: '#',
      accessor: (row, index) => (
        <div className="d-flex align-items-center pl-4">
          <div>
            <h4 className="text-dark-75 font-weight-bolder mb-1 font-size-sm">
              {index + 1}
            </h4>
          </div>
        </div>
      ),
      minWidth: 50,
      width: 50,
    },
    {
      Header: 'z name',
      accessor: 'product_name',
      paddingLeft: '0px',
    },
    {
      Header: 'Product code',
      accessor: 'product_code',
      paddingLeft: '0px',
    },
    {
      Header: 'Barcode',
      accessor: 'barcode',
      paddingLeft: '0px',
    },

    {
      Header: 'Store',
      accessor: 'store_name',
      minWidth: 200,
      paddingLeft: '0px',
    },
    {
      Header: 'Total Sold quantity',
      accessor: 'totalSoldQty',
      paddingLeft: '0px',
    },
    {
      Header: 'Total Sold amount',
      accessor: 'totalSoldAmount',
      paddingLeft: '0px',
    },
    {
      Header: 'Total Vat',
      accessor: 'totalVat',
      paddingLeft: '0px',
    },
    {
      Header: 'Total Discount',
      accessor: 'totalDiscount',
      paddingLeft: '0px',
    },
  ]);

  const getStorewiseproductReport = async () => {
    setGenerateReport(true);
    const { data } = await Axios.get(
      `${process.env.REACT_APP_API_URL}/report/productReportStoreWise`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
          refreshToken: refreshToken,
        },
      }
    );
    if (!data.error) {
      setStorewiseproductReport(data.finalData);
      const singleData = data.finalData[0];
      const makeHeader = [];
      for (let key in singleData) {
        makeHeader.push({ label: key, key: key });
      }
      setHeaders(makeHeader);
      setGenerateReport(false);
    } else {
      swal({
        title: 'Something went wrong',
        icon: 'error',
      });
    }
    setGenerateReport(false);
  };

  const [headers2, setHeaders2] = useState([]);
  const [headers3, setHeaders3] = useState([]);
  const [headers4, setHeaders4] = useState([]);
  const [itemWiseReport, setItemWiseReport] = useState([]);
  const [areaWiseReport, setAreaWiseReport] = useState([]);
  const [shopWiseReport, setShopWiseReport] = useState([]);

  // common getter data async func
  const getReportData = async (url, setData, setHeader) => {
    const searchData = {
      start_date: date_from,
      end_date: date_to,
    };
    const { data } = await Axios.post(
      `${process.env.REACT_APP_API_URL}/report/${url}/B2C`,
      searchData,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
          refreshToken: refreshToken,
        },
      }
    );
    if (!data.error) {
      setData(data.data);
      const singleData = data.data[0];
      const makeHeader = [];
      for (let key in singleData) {
        makeHeader.push({ label: key, key: key });
      }
      setHeader(makeHeader);
    } else {
      swal({
        title: 'Something went wrong',
        icon: 'error',
      });
    }
  };

  // Content
  return (
    <div className="card">
      <div className="card-header border-0 d-flex justify-content-between pb-0">
        <h3 className="card-title mb-0">Productwise Sale Report</h3>
        <Dropdown>
          <Dropdown.Toggle variant="primary" id="dropdown-basic">
            Download Report
          </Dropdown.Toggle>

          <Dropdown.Menu className="p-3">
            <CSVLink
              className="btn btn-secondary"
              data={storewiseproductReport}
              headers={headers}
              filename="Storewise Stock Report"
            >
              Storewise Stock
            </CSVLink>
            <CSVLink
              className="btn btn-secondary mt-2 w-100"
              data={itemWiseReport}
              headers={headers2}
              filename="Itemwise Sales report"
            >
              Itemwise Sales
            </CSVLink>

            <CSVLink
              className="btn btn-secondary mt-2 w-100"
              data={shopWiseReport}
              headers={headers4}
              filename="Shopwise Sales report"
            >
              Shopwise Sales
            </CSVLink>
          </Dropdown.Menu>
        </Dropdown>
      </div>

      <div className="card-body">
        <div className="row mb-5">
          <div className="col-md-4">
            <label>Select City</label>
            <Select
              allowClear
              showSearch
              style={{ width: '100%' }}
              placeholder="Select Store"
              optionFilterProp="children"
              onChange={(value) => setCity(value)}
              value={city}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {citiesList &&
                citiesList.map(({ id, name }) => (
                  <Option key={id} value={id}>
                    {name}
                  </Option>
                ))}
            </Select>
          </div>

          <div className="col-md-4">
            <label>Select Area</label>
            <Select
              allowClear
              showSearch
              style={{ width: '100%' }}
              placeholder="Select area"
              optionFilterProp="children"
              onChange={(value) => setArea(value)}
              value={area}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {areasList &&
                areasList.map(({ id, name }) => (
                  <Option key={id} value={id}>
                    {name}
                  </Option>
                ))}
            </Select>
          </div>

          <div className="col-md-4">
            <label>Select Store</label>
            <Select
              allowClear
              showSearch
              style={{ width: '100%' }}
              placeholder="Select Store"
              optionFilterProp="children"
              onChange={(value) => setStore(value)}
              value={store}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {storeData &&
                storeData.map(({ id, name }) => (
                  <Option key={id} value={id}>
                    {name}
                  </Option>
                ))}
            </Select>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="d-flex" style={{ flexDirection: 'column' }}>
              <label>
                {' '}
                Start Date<span className="text-danger">*</span>
              </label>
              <Space direction="vertical" size={12}>
                <DatePicker
                  style={{ width: '100%', marginRight: '10px' }}
                  format={dateFormat}
                  placeholder="MM/DD/YYYY"
                  defaultValue={moment(date_from)}
                  onChange={(date, dateString) => setDate_from(dateString)}
                />
              </Space>
            </div>
          </div>
          <div className="col-md-4">
            <div className="d-flex" style={{ flexDirection: 'column' }}>
              <label>
                {' '}
                End Date<span className="text-danger">*</span>
              </label>
              <Space direction="vertical" size={12}>
                <DatePicker
                  style={{ width: '100%', marginRight: '10px' }}
                  format={dateFormat}
                  placeholder="MM/DD/YYYY"
                  defaultValue={moment(date_to)}
                  onChange={(date, dateString) => setDate_to(dateString)}
                />
              </Space>
            </div>
          </div>

          <div className="col-md-2 text-right mt-10">
            <button
              className="btn btn-primary w-75"
              onClick={handleSearch}
              disabled={loading}
            >
              Search{' '}
              {loading && (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
            </button>
          </div>
        </div>
      </div>
      {saleReportTable && (
        <TableComponent
          columns={columns}
          data={data}
          title="Sale Report Table"
          hideAddButton={true}
          lists={saleReportList}
        />
      )}
    </div>
  );
}
